"use strict";

(function () {
  "use strict";

  angular.module("schedules.planning").factory("ScheduleRules", ScheduleRules);

  function ScheduleRules() {
    var TZ = "Europe/Paris";
    // Index RRule : 0 = lundi … 6 = dimanche.
    var WEEKDAYS = [RRule.MO, RRule.TU, RRule.WE, RRule.TH, RRule.FR, RRule.SA, RRule.SU];
    var SIMPLE_OPTIONS = ["freq", "interval", "wkst", "byweekday", "until", "dtstart"];

    var at = function at(date, time) {
      return moment.tz(date + " " + time, "YYYY-MM-DD HH:mm", TZ).toDate();
    };

    // Lit une plage « chaque semaine, certains jours » ; null si la règle est trop complexe pour la fenêtre.
    function parse(schedule) {
      if (!schedule.rrule || !schedule.rrule.rrule) return null;

      var options = RRule.rrulestr(schedule.rrule.rrule, { dtstart: new Date(schedule.fromDate) }).origOptions;
      var isSimple = Object.keys(options).every(function (key) {
        return SIMPLE_OPTIONS.indexOf(key) > -1;
      }) && (!options.interval || options.interval === 1) && (options.freq === RRule.WEEKLY || options.freq === RRule.DAILY && !options.byweekday);
      if (!isSimple) return null;

      var weekdays = options.byweekday ? [].concat(options.byweekday).map(function (day) {
        return typeof day === "number" ? day : day.weekday;
      }) : options.freq === RRule.WEEKLY ? [(new Date(options.dtstart).getUTCDay() + 6) % 7] : [0, 1, 2, 3, 4, 5, 6];
      var end = schedule.endDate || schedule.rrule.until;

      return {
        id: schedule._id,
        weekdays: weekdays.sort(),
        startTime: schedule.startTime,
        endTime: schedule.endTime,
        until: end ? moment(end).tz(TZ).format("YYYY-MM-DD") : ""
      };
    }

    // Vérifie une plage saisie ; renvoie le message d'erreur ou null.
    function validate(plage) {
      if (!plage.weekdays.length) return "Chaque plage doit avoir au moins un jour.";
      if (!plage.startTime || !plage.endTime) return "Les heures de début et de fin sont obligatoires.";
      if (plage.endTime <= plage.startTime) return "L'heure de fin doit être après l'heure de début.";
      return null;
    }

    // Construit les champs à enregistrer, calculés comme l'ancien formulaire (fromDate, endDate, rrule).
    function toVals(plage, fromDay) {
      var rule = new RRule({
        freq: RRule.WEEKLY,
        interval: 1,
        wkst: RRule.SU,
        byweekday: plage.weekdays.map(function (day) {
          return WEEKDAYS[day];
        })
      });
      var until = plage.until ? at(plage.until, "00:00") : null;

      return {
        fromDate: at(fromDay, plage.startTime),
        startTime: plage.startTime,
        endTime: plage.endTime,
        endDate: plage.until ? at(plage.until, plage.endTime) : null,
        rrule: {
          rrule: "RRULE:" + rule.toString(),
          description: rule.toText("FRENCH"),
          until: until,
          frequencyName: "Chaque semaine"
        }
      };
    }

    // Une plage est encore en cours si elle n'a pas de fin ou finit aujourd'hui ou plus tard.
    function isCurrent(schedule, today) {
      var end = schedule.endDate || schedule.rrule && schedule.rrule.until;
      if (!schedule.rrule || !schedule.rrule.rrule) {
        end = schedule.fromDate;
      }
      return !end || moment(end).tz(TZ).format("YYYY-MM-DD") >= today;
    }

    return { parse: parse, validate: validate, toVals: toVals, isCurrent: isCurrent };
  }
})();